(function() {

    // Utility
    function getCORS(url, success) {
	    var xhr = new XMLHttpRequest();
	    if (!('withCredentials' in xhr)) xhr = new XDomainRequest(); // fix IE8/9
	    xhr.open('GET', url);
	    xhr.onload = success;
	    xhr.send();
	    return xhr;
	}

    // Get html from json file that is written by sonic
    getCORS("/json/staff-menu.json", function(request) {

        var response = request.currentTarget.response || request.target.responseText;
        var response_json = JSON.parse(response);

        // Replace HTML content of all matching targets with above
        var containers = document.querySelectorAll('.masthead_staff_menu');
        if(containers.length > 0) {
            for(var i = 0; i < containers.length; i++) {
                containers[i].innerHTML = response_json["html"];
            }
        }

        //homepage navigation touch/click handlers
        var homeNavClick = function(e){

            var ele = $(e.target.parentNode);
            var menu = ele.find("ul");
            $( menu ).toggle();
        }

        //homepage navigation mouse event handlers
        var mainNavHover = function(){

            var over_submenu = false;

            $(".main-nav-bar .masthead_staff_menu").parent().hover(
                function () {
                    $(this).find('ul.hoverMenu').show();
                },
                function () {
                    $(this).find('ul.hoverMenu').hide();
                }
            );
        }

        //homepage hover menu handlers
        //smart check for touch events to cover all devices without device/width checks
        $(".main-nav-bar .masthead_staff_menu").parent().find("a").on({
            mouseenter: function(e) {
                mainNavHover(e);
            }, touchstart: function(e) {
                homeNavClick(e);
            }, touchmove: function(e) {
                homeNavClick(e);
            }
        });
    });

})();